export default {"src":"/_next/static/media/apply.cd258a6e.svg","height":357,"width":499,"blurWidth":0,"blurHeight":0};